import { configureStore } from '@reduxjs/toolkit';
import layoutSlice from './slices/layoutSlice';
import clusterSlice from './slices/clusterSlice';
import kopClusterSlice from './slices/kopClusterSlice';
import dictSlice from './slices/dictSlice';
import authSlice from './slices/authSlice';
import utilSlice from './slices/utilSlice';
import permissionsSlice from './slices/permissionsSlice';
import tenantSlice from './slices/tenantSlice';
import zookeeperSlice from './slices/zookeeperSlice';
import bookkeeperSlice from './slices/bookkeeperSlice';
import brokerSlice from './slices/brokerSlice';
import namespaceSlice from './slices/namespaceSlice';
import topicSlice from './slices/topicSlice';
import templateSlice from './slices/templateSlice';
import resourceSlice from './slices/resourceSlice';
import execFlowSlice from './slices/execFlowSlice';
import execComponentSlice from './slices/execComponentSlice';
import execRecordSlice from './slices/execRecordSlice';
import execScriptSlice from './slices/execScriptSlice';
import roleSlice from './slices/roleSlice';
import functionSlice from './slices/functionSlice';
import variableSlice from './slices/variableSlice';
import execVariableSlice from './slices/execVariableSlice';
import messageSARSlice from './slices/messageSARSlice';
import messageTraceSlice from './slices/messageTrace';
import kopTopicSlice from './slices/kopTopicSlice';
import kopConsumerGroupSlice from './slices/kopConsumerGroupSlice';
import kopPermissionsSlice from './slices/kopPermissionsSlice';
import kafkaPermissionsSlice from './slices/kafkaPermissionsSlice';
import kopNamespaceSlice from './slices/kopNamespaceSlice';
import kopBrokerSlice from './slices/kopBrokerSlice';
import kopBookkeeperSlice from './slices/kopBookkeeperSlice';
import kopZookeeperSlice from './slices/kopZookeeperSlice';
import kopTenantSlice from './slices/kopTenantSlice';
import kafkaBrokerSlice from './slices/kafkaBrokerSlice';
import codeSampleSlice from './slices/codeSampleSlice';
import organizeSlice from './slices/organizeSlice';
import serviceDiscoverySlice from './slices/serviceDiscoverySlice';
import platformSlice from './slices/platformSlice';

export const store = configureStore({
  reducer: {
    layout: layoutSlice,
    cluster: clusterSlice,
    dict: dictSlice,
    auth: authSlice,
    util: utilSlice,
    permissions: permissionsSlice,
    tenant: tenantSlice,
    zookeeper: zookeeperSlice,
    bookkeeper: bookkeeperSlice,
    broker: brokerSlice,
    namespace: namespaceSlice,
    topic: topicSlice,
    template: templateSlice,
    resource: resourceSlice,
    execFlow: execFlowSlice,
    execComponent: execComponentSlice,
    execRecord: execRecordSlice,
    execScript: execScriptSlice,
    role: roleSlice,
    function: functionSlice,
    variable: variableSlice,
    execVariable: execVariableSlice,
    messageSAR: messageSARSlice,
    messageTrace: messageTraceSlice,
    kopCluster: kopClusterSlice,
    kopTopic: kopTopicSlice,
    kopConsumerGroup: kopConsumerGroupSlice,
    kopPermissions: kopPermissionsSlice,
    kafkaPermissions: kafkaPermissionsSlice,
    kopNamespace: kopNamespaceSlice,
    kopBroker: kopBrokerSlice,
    kopBookkeeper: kopBookkeeperSlice,
    kopZookeeper: kopZookeeperSlice,
    kopTenant: kopTenantSlice,
    kafkaBroker: kafkaBrokerSlice,
    codeSample: codeSampleSlice,
    organize: organizeSlice,
    serviceDiscovery: serviceDiscoverySlice,
    platform: platformSlice,
  },
});
